import React from 'react';

function SvgEchIconTools2(props: React.SVGProps<SVGSVGElement>) {
  const iconUuid = React.useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 100 100"
      {...props}
    >
      <defs>
        <linearGradient
          id={`${iconUuid}_a`}
          x1={485.49}
          y1={33.85}
          x2={485.49}
          y2={13.35}
          gradientTransform="matrix(0, -0.77, -1.01, 0, 80.1, 413.6)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ec6508" />
          <stop offset={1} stopColor="#f3921c" />
        </linearGradient>
        <linearGradient
          id={`${iconUuid}_b`}
          x1={81.1}
          y1={86.19}
          x2={14.1}
          y2={19.18}
          gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
          xlinkHref={`#${iconUuid}_a`}
        />
      </defs>
      <rect
        fill={`url(#${iconUuid}_a)`}
        stroke={`url(#${iconUuid}_a)`}
        strokeWidth={5}
        x={46.05}
        y={37.38}
        width={20.62}
        height={1.51}
        transform="translate(-10.46 51.02) rotate(-45)"
      />
      <path
        fill={`url(#${iconUuid}_b)`}
        stroke={`url(#${iconUuid}_b)`}
        strokeWidth={5}
        d="M66.22,55.54a7.53,7.53,0,0,0-7.7-1.8L55.81,51,69.45,37.39l8.9,8.9L88.58,36.06,67.15,14.63,56.77,14l-5.35,5.36,17,17L54.74,50,22.59,17.83l-.34-.34-.48-.08-3.16-.5-1.93-.31.2,1.94.34,3.32.06.53.38.38,26.51,26.5L15.37,78.06l6.7,6.7L50.87,56l2.79,2.79a7.57,7.57,0,0,0,1.88,7.46L73.59,84.28a6.66,6.66,0,0,0,9.42,0L84.26,83a6.68,6.68,0,0,0,0-9.43Zm-8.87-40,9.14.55,20,20-8.11,8.11L53.54,19.36Zm-39,2.85,3.16.5L57.19,54.53l-2.82,2.81L18.72,21.71Zm3.7,64.24L17.5,78.06,45.23,50.33,49.8,54.9ZM83.2,82,82,83.22a5.17,5.17,0,0,1-7.3,0L56.6,65.15a6,6,0,0,1-1.24-6.67l3.1-3.11a6.17,6.17,0,0,1,2.46-.52,6,6,0,0,1,4.23,1.75l18,18.06A5.17,5.17,0,0,1,83.2,82Z"
      />
    </svg>
  );
}
export default SvgEchIconTools2;
